import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEditSmall2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEditSmall2"><Path d="M23.4142 5.00015L19 0.585938L12 7.58594V12.0002H16.4142L23.4142 5.00015Z" fill="currentColor"/><Path d="M3 3.00012H12V5.00012H5V19.0001H19V12.0001H21V21.0001H3V3.00012Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEditSmall2;
